import CustomTable from '@/components/CustomTable/CustomTable.vue';
import NavBar from '@/components/NavBar/NavBar.vue';
import { API_BASE_URL } from "@/config";
import { format_date } from "@/utils/date_formatter";
import { useToast } from "@/components/Toast/useToast";
import Swal from 'sweetalert2';

export default {
  name: 'ViewCustomers',
  setup() {
    const { showSuccess, showError } = useToast();
    return { showSuccess, showError };
  },
  components: {
    NavBar,
    CustomTable
  },
  data: () => ({
    customers: [],
    columns: [
      { label: 'Name', key: 'name_email' },
      { label: 'Phone Number', key: 'phone_number' },
      { label: 'Date Joined', key: 'date_joined' },
    ]
  }),
  methods: {
    formatDate(date) {
      return format_date(date);
    },
    getCustomers(page = 1, search = '') {
      const TOKEN = localStorage.getItem('token');
      return new Promise((resolve, reject) => {
        let url = `${API_BASE_URL}/verify_api/system_management_api/get_customers_api/?page=${page}`;
        if (search) {
          url += `&search=${encodeURIComponent(search)}`;
        }
        $.ajax({
          url: url,
          method: 'GET',
          dataType: 'json',
          headers: {
            Authorization: `Token ${TOKEN}`
          },
          success: function(data) {
            resolve({
              count: data.count,
              results: data.results,
            });
          },
          error: function(xhr, status, error) {
            reject(error);
          }
        });
      });
    },
    viewCustomer(user_id) {
      this.$router.push({ name: 'view_customer', params: { user_id: user_id } });
    },

    toggleUserStatus(row) {
      const action = row.is_active ? 'deactivate' : 'activate';
      const actionText = row.is_active ? 'Deactivate' : 'Activate';
      
      Swal.fire({
        title: `${actionText} User?`,
        text: `Are you sure you want to ${action} ${row.full_name || (row.first_name + ' ' + row.last_name)}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: row.is_active ? '#d33' : '#28a745',
        cancelButtonColor: '#6c757d',
        confirmButtonText: `Yes, ${action}!`,
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.isConfirmed) {
          this.performUserStatusToggle(row.id, action);
        }
      });
    },

    performUserStatusToggle(userId, action) {
      const TOKEN = localStorage.getItem('token');
      const endpoint = action === 'deactivate' ? 'deactivate_user_api' : 'activate_user_api';
      const url = `${API_BASE_URL}/verify_api/verify_admin_api/${endpoint}/${userId}`;

      $.ajax({
        url: url,
        method: 'POST',
        headers: { Authorization: `Token ${TOKEN}` },
        success: (response) => {
          this.showSuccess(response.message);
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        },
        error: (error) => {
          this.showError(error.responseJSON?.error || `Failed to ${action} user`);
        }
      });
    }
  },
  mounted() {
    this.getCustomers();
  }
};
